import {
    ChangeDetectorRef,
    Component,
    HostListener,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ReferalFormService } from '../shared/referal-form.service';
import { environment } from 'src/environments/environment';
import { VendorService } from '../shared/vendor.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  standalone: false,
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.css', '../shared/css/common.css'],
})
export class UploadFileComponent implements OnInit, OnDestroy {
    @ViewChild('attachmentAddForm') attachmentAddForm: NgForm | undefined;

    newAttachments: any = [];
    FilesToUpload: any = [];
    canUpload: boolean = true;
    doneUpload: boolean | undefined;
    fileUploadFailed: boolean = false;
    htmlNote: string | undefined;
    selectedNoteID: string | undefined;
    noteAttachmentKeyValue: number | undefined;
    BufferChunkSize: number = 0;
    failedAttachmentKey: boolean = false;
    hasUpdate: boolean = false;
    LargeFileStart: any;
    sourceAppKey: number = 10;

    public formdata: any | null;
    error: string = '';
    existFiles: any[] = [];
    AttachmentNameList: any;

    noteAttachmentKey: number | undefined;
    activityKey: number | undefined;
    countAddingAttachmentToDb: number = -1;
    keyOfFilesmall: any;
    uploadChunks: number | undefined;
    caseKey: number | undefined;
    caseTypeKey: number | undefined;
    leadKey: number | undefined;
    activityType: string | undefined;
    activity: any = [];
    keyOfFile: any;
    payorKey: any;

    payorkey: number;
    uploadInstructionalText: string = '';
    reUploadInstructionalText: string = '';
    permanentInstructionalText: string = 'Navigating to previous pages may result in files you attached for upload to be removed. Please upload files as the final step before submitting this referral.';
    filesReadyForUpload: any = [];

    leadKeyForUploads: any;
    caseActivityKeyForUploads: any;

    fullAttachmentKeyList: any[] = [];
    primaryColor?: string = "";

    showReUploadModal: boolean = false;
    showFileUploadStatus: boolean = false;
    alreadyUploadedFilesAttachmentKeys: any[] = [];
    @Input()
    showUploadSection: boolean = false;
    showAttachmentLoader: boolean = false;

    private uploadStartDataSub!: Subscription;

    constructor(
        private referalService: ReferalFormService,
        private cdref: ChangeDetectorRef,
        private zone: NgZone,
        private vendorService: VendorService,
        private fcservice: VendorService,
        private router: Router,
        private ngxsippner: NgxSpinnerService
    ) {
        this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
    }

    ngOnInit(): void {
        this.formdata = JSON.parse(
            sessionStorage.getItem('activeformdata') ?? '{}'
        );

        if (this.formdata && Object.keys(this.formdata).length == 0) {
            this.formdata = this.referalService.getFormLoadJSON();
            this.cdref.detectChanges();
            sessionStorage.setItem('activeformdata', JSON.stringify(this.formdata));
        } else {
            if (this.formdata.newAttachments) {
                this.newAttachments = this.formdata.newAttachments;
            }
        }

        this.vendorService.getRequiredFields(this.payorkey).subscribe((result) => {
            this.uploadInstructionalText = result.UploadInstructionalText;
        });

        this.reUploadInstructionalText = 'All failed uploads have been removed. If you wish to add or replace files, please attach the files below (optional). When finished, click ‘Submit.’';

        this.payorKey = parseInt(sessionStorage.getItem("payorkey") ?? "0");

        this.uploadStartDataSub = this.vendorService
            .getUploadStartData()
            .subscribe((data) => {
                if (data.IsSuccess && !this.showUploadSection) {
                    this.FilesToUpload = this.vendorService.FilesToUpload;
                    this.filesReadyForUpload = this.vendorService.filesReadyForUpload;
                    this.leadKeyForUploads = data.LeadKey;
                    this.caseActivityKeyForUploads = data.CaseActivityKey;
                    this.uploadFiles();
                }
            });
        setTimeout(() => {
            if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
                const colorFromStorage = localStorage.getItem('primaryCssColor');
                this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
                document.documentElement.style.setProperty('--primary-color', this.primaryColor);
            }
        }, 0);

        let currentUrl = window.location.hash;
        if(!currentUrl.includes('submit')) {
            this.FilesToUpload = [];
            this.filesReadyForUpload = [];
            this.vendorService.FilesToUpload = this.FilesToUpload;
            this.vendorService.filesReadyForUpload = this.filesReadyForUpload;
            this.vendorService.sendUploadFileData(this.FilesToUpload);
        }
    }

    //<START> CODE ADDED FOR NEW UPLOAD FUNCTIONALITY

    clearFileInput(event: any) {
        event.target.value = '';
    }

    removeFile(file: any) {
        this.FilesToUpload = this.FilesToUpload.filter((f: any) => f !== file);
        this.vendorService.FilesToUpload = this.FilesToUpload;
        this.removeFileFromReadyForUpload(file.fileName);
        this.vendorService.sendUploadFileData(this.FilesToUpload);
    }

    removeAndReplaceErrorFiles() {
        this.showReUploadModal = true;
        this.ngxsippner.show('file-upload');
        this.showFileUploadStatus = false;
        this.FilesToUpload = this.FilesToUpload.filter((f: any) => f.percentage == 100);
        this.vendorService.FilesToUpload = this.FilesToUpload;
        let arrayfiles: File[] = [];
        this.filesReadyForUpload.forEach((item: any) => {
            if (item instanceof FileList) {
                arrayfiles.push(...Array.from(item));
            } else if (Array.isArray(item)) {
                arrayfiles.push(...item);
            } else if (item instanceof File) {
                arrayfiles.push(item);
            }
        });
        this.filesReadyForUpload = arrayfiles.filter((f: any) =>
            this.FilesToUpload.some((file: any) => file.fileName === f.name)
        );
        this.vendorService.filesReadyForUpload = this.filesReadyForUpload;

        this.alreadyUploadedFilesAttachmentKeys = this.FilesToUpload
            .filter((f: any) => f.percentage === 100 && f.attachmentKey !== undefined)
            .map((f: any) => f.attachmentKey);
        this.vendorService.sendUploadFileData(this.FilesToUpload);
    }

    get hasErrorInUpload(): boolean {
        return (
            this.FilesToUpload.length > 0 &&
            this.FilesToUpload.every((f: any) => f.percentage >= 100) &&
            this.FilesToUpload.some((f: any) => f.percentage === 500 || f.percentage === 600)
        );
    }

    onFileChange(event: any) {
        this.handleFileSelect(event.target);
        event.target.value = '';
    }

    handleFileSelect(event: any) {
        this.error = "";
        if (event === null || event === undefined) {
            this.vendorService.sendUploadFileData(this.FilesToUpload);
            return;
        }

        var files = event.files ? event.files : event;

        let newFiles: File[] = [];
        if (files instanceof FileList) {
            newFiles = Array.from(files);
        } else if (Array.isArray(files)) {
            newFiles = files;
        } else if (files instanceof File) {
            newFiles = [files];
        }

        if (newFiles.length === 0) {
            this.vendorService.sendUploadFileData(this.FilesToUpload);
            return;
        }

        for (let file of newFiles) {
            if (file.name !== undefined) {
                this.FilesToUpload = this.FilesToUpload.filter((f: any) => f.fileName !== file.name);
                this.removeFileFromReadyForUpload(file.name);

                if (!this.checkFileType(file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length))) {
                    this.error += 'Invalid file extension for file: ' + file.name + "<br />";
                }
                else {
                    let fileSize = file.size !== undefined ? file.size : 0;
                    let totalFileSize = this.FilesToUpload.reduce((total: any, attachment: any) => total + attachment.fileSize, 0);
                    
                    if ((totalFileSize + fileSize) > 1500000000) {
                        this.error += 'The total file size exceeds the limit of 1.5 GB. File Name: ' + file.name + '<br />';
                    }
                    else {
                        this.filesReadyForUpload.push(file);

                        var attachment = { fileName: "", fileType: "", percentage: 0, fileSize: 0, sizeReadable: 0, failureToUpload: false };
                        attachment.fileName = file.name.substring(file.name.lastIndexOf('\\') + 1);
                        attachment.fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
                        attachment.fileName = this.ReplaceCurlyQuotesInFileName(attachment.fileName);
                        
                        const newIndex = this.FilesToUpload.length;
                        this.FilesToUpload.push(attachment);
                        this.FilesToUpload[newIndex].percentage = 0;
                        this.FilesToUpload[newIndex].noOfchunksSent = 0;
                        this.FilesToUpload[newIndex].fileSize = fileSize;
                        this.FilesToUpload[newIndex].fileId = newIndex;
                        this.FilesToUpload[newIndex].sizeReadable = this.humanFileSize(fileSize, true);
                        this.FilesToUpload[newIndex].failureToUpload = false;
                        this.FilesToUpload[newIndex].uploadedBytesConfirmed = 0;
                        this.FilesToUpload[newIndex].scanStatus = 0;
                    }
                }
            }
        }

        this.vendorService.FilesToUpload = this.FilesToUpload;
        this.vendorService.filesReadyForUpload = this.filesReadyForUpload;
        this.vendorService.sendUploadFileData(this.FilesToUpload);
    }

    private removeFileFromReadyForUpload(fileName: string) {
        this.filesReadyForUpload = this.filesReadyForUpload.filter((item: any) => {
            if (item instanceof FileList) {
                return !Array.from(item).some((f: any) => f.name === fileName);
            } else if (Array.isArray(item)) {
                return !item.some((f: any) => f.name === fileName);
            } else if (item instanceof File) {
                return item.name !== fileName;
            }
            return true;
        });

        this.vendorService.filesReadyForUpload = this.filesReadyForUpload;
    }

    reUploadNewFiles() {
        this.uploadFiles();
        this.showFileUploadStatus = true;
        this.showReUploadModal = false;
    }

    uploadFiles() {
        this.countAddingAttachmentToDb = -1;
        var filesAlreadyUploaded = this.FilesToUpload.filter((f: any) => f.percentage === 100);
        var files = this.filesReadyForUpload;
        if (filesAlreadyUploaded.length === files.length) {
            this.fcservice.pollStatus(5000, this.alreadyUploadedFilesAttachmentKeys).subscribe(status => {
                if (status) {
                    console.log('Condition met, stopping polling.', status);
                    this.updateScanStatusPerFile(status);
                    let allClean = true;
                    if (Array.isArray(status)) {
                        status.forEach(item => {
                            if (item.VirusScanStatus !== 1 && item.fileName && this.FilesToUpload.some((f: any) => f.fileName === item.fileName)) {
                                allClean = false;
                            }
                        });
                    } else {
                        allClean = false;
                    }
                    if (allClean) {
                        this.vendorService.sendUploadEndData(true);
                    }
                }
                else {
                    console.log('Condition not met, polling continues.');
                }
            });
            
            return;
        }
        if (files != null || files != undefined) {
            this.zone.run(() => {
                this.FilesToUpload = [];
                this.existFiles = [];
                let arrayfiles: File[] = [];
                this.filesReadyForUpload.forEach((item: any) => {
                    if (item instanceof FileList) {
                        arrayfiles.push(...Array.from(item));
                    } else if (Array.isArray(item)) {
                        arrayfiles.push(...item);
                    } else if (item instanceof File) {
                        arrayfiles.push(item);
                    }
                });

                if (arrayfiles.length > 0) {
                    this.ngxsippner.show('file-upload');
                    this.showFileUploadStatus = true;
                    this.cdref.detectChanges();
                    this.canUpload = false;
                    for (var i = 0; i < arrayfiles.length; i++) {
                        if (arrayfiles[i].name !== undefined) {
                            if (!this.checkFileType(arrayfiles[i].name.substring(arrayfiles[i].name.lastIndexOf('.') + 1, arrayfiles[i].name.length))) {
                                //this.notificationService.add({ type: 'info', title: this.notificationTranslate['Invalid Extension'], body: this.notificationTranslate['Invalid file extension for file:'] + this.FilesToUpload[i].fileName });
                                const fileNameToRemove = arrayfiles[i].name;
                                let allFiles: File[] = [];
                                this.filesReadyForUpload.forEach((item: any) => {
                                    if (item instanceof FileList) {
                                        allFiles.push(...Array.from(item));
                                    } else if (Array.isArray(item)) {
                                        allFiles.push(...item);
                                    } else if (item instanceof File) {
                                        allFiles.push(item);
                                    }
                                });
                                allFiles = allFiles.filter(file => file.name !== fileNameToRemove);
                                this.filesReadyForUpload = [allFiles];
                            }
                            else {
                                var attachment = { fileName: "", fileType: "", percentage: 0, fileSize: 0, sizeReadable: 0, failureToUpload: false };
                                attachment.fileName = arrayfiles[i].name.substring(arrayfiles[i].name.lastIndexOf('\\') + 1);
                                attachment.fileType = arrayfiles[i].name.substring(arrayfiles[i].name.lastIndexOf('.') + 1, arrayfiles[i].name.length);
                                attachment.fileName = this.ReplaceCurlyQuotesInFileName(attachment.fileName);
                                this.FilesToUpload.push(attachment);
                                this.FilesToUpload[i].percentage = 0;
                                this.FilesToUpload[i].noOfchunksSent = 0;
                                this.FilesToUpload[i].fileSize = arrayfiles[i].size !== undefined ? arrayfiles[i].size : 0;
                                this.FilesToUpload[i].fileId = i;
                                this.FilesToUpload[i].sizeReadable = this.humanFileSize(this.FilesToUpload[i].fileSize, true);
                                this.FilesToUpload[i].failureToUpload = false;
                                this.FilesToUpload[i].uploadedBytesConfirmed = 0;
                                this.FilesToUpload[i].scanStatus = 0;
                                if (filesAlreadyUploaded.some(
                                    (f: any) => f.fileName === this.FilesToUpload[i].fileName
                                )
                                ) {
                                    this.FilesToUpload[i].percentage = 100;
                                    this.FilesToUpload[i].failureToUpload = false;
                                    this.FilesToUpload[i].scanStatus = 1;
                                }
                                else {
                                    this.addAttachmentToDb(this.FilesToUpload[i], arrayfiles[i], i);
                                }
                            }
                        }
                    }
                }
                else {
                    this.vendorService.sendUploadEndData(true);
                }
            });
        }
        else {
            this.vendorService.sendUploadEndData(true);
            //this.router.navigate(['final']);
        }

        this.vendorService.sendUploadFileData(this.FilesToUpload);
    }

    addAttachmentToDb(attachment: any, targetFile: any, i: any) {
        this.FilesToUpload[i].sourceAppKey = this.sourceAppKey;
        this.FilesToUpload[i].noteAttachmentKey = this.leadKeyForUploads;
        this.FilesToUpload[i].activityKey = this.caseActivityKeyForUploads;
        this.FilesToUpload[i].sourceKey = this.leadKeyForUploads
        this.FilesToUpload[i].attachmentLength = attachment.fileSize;
        this.FilesToUpload[i].targetFile = targetFile;
        this.FilesToUpload[i].payorKey = this.payorKey;
        attachment.sourceKey = this.leadKeyForUploads;
        attachment.activityKey = this.caseActivityKeyForUploads;
        this.fcservice.addAttachmentToDB(attachment).subscribe(
            (data: any) => {
                var attachmentKey = data.attachmentKey;
                if (attachmentKey === -1 || attachmentKey === 0) {
                    var idx = this.FilesToUpload.findIndex((x: any) => {
                        return x.fileId === i;
                    });
                    if (idx > -1) {
                        this.FilesToUpload.splice(idx, 1);
                    }
                }
                else {
                    this.countAddingAttachmentToDb++;
                    var idx1 = this.FilesToUpload.findIndex((x: any) => {
                        return x.fileId === i;
                    });
                    if (idx1 > -1) {
                        this.FilesToUpload[idx1].attachmentKey = attachmentKey;
                    }
                }
                if (this.countAddingAttachmentToDb === this.FilesToUpload.filter((f: any) => f.percentage !== 100).length - 1) {

                    this.FilesToUpload = this.FilesToUpload.sort((a: any, b: any) => a.size - b.size);

                    this.processFiles();
                }
            }
        );
    }

    processFiles() {
        for (var i = 0; i < this.FilesToUpload.length; i++) {
            if (this.FilesToUpload[i].percentage != 100) {
                if (this.FilesToUpload[i].attachmentKey && Math.abs(parseInt(this.FilesToUpload[i].fileSize)) >= 1024 * 1024 * 2) {
                    this.createandUploadChunks(this.FilesToUpload[i], this.FilesToUpload[i].targetFile, i);
                }
                else {
                    if (this.FilesToUpload[i].attachmentKey != this.failedAttachmentKey) {
                        this.upload(this.FilesToUpload[i].targetFile, i, null, this.FilesToUpload[i].fileSize, this.FilesToUpload[i].fileName,
                            0, this.FilesToUpload[i].attachmentKey);
                    }
                }
            }
        }

        this.LargeFileStart = null;
        this.FilesToUpload.forEach((value: any, key: any) => {
            if (parseInt(value.fileSize) >= (1024 * 1024) * 2) {
                if (this.LargeFileStart == null) {
                    this.LargeFileStart = key;
                }
            }
        });
        if (this.LargeFileStart != null && (this.FilesToUpload[this.LargeFileStart].fileSize >= (1024 * 1024) * 2)) {
            this.nextBatchProcess(this.LargeFileStart);
        }
    }

    createandUploadChunks(attachment: any, targetFile: any, i: any) {
        var fileChunks: any = [];
        var Size = attachment.fileSize;
        var num = (1024 * 1024) * 2;
        this.BufferChunkSize = 0;
        if (Size / num > 256) {
            this.BufferChunkSize = Size / 256;
        }
        else
            this.BufferChunkSize = (1024 * 1024) * 2;
        var ReadBuffer_Size = 1024;
        var FileStreamPos = 0;
        var EndPos = this.BufferChunkSize;

        var fileChunkId = 0;
        while (FileStreamPos < Size) {
            fileChunks.push({ targetFile: targetFile.slice(FileStreamPos, EndPos), id: fileChunkId });
            FileStreamPos = EndPos;
            EndPos = FileStreamPos + this.BufferChunkSize;
            fileChunkId++;
        }
        this.FilesToUpload[i].fileChunksLength = fileChunks.length;
        this.FilesToUpload[i].fileChunks = fileChunks;
    }

    nextBatchProcessNewFile(i: any) {
        if (this.FilesToUpload[i] != undefined && this.FilesToUpload[i] != null) {
            if (this.FilesToUpload[i].percentage == 100 || this.FilesToUpload[i].percentage == 600 || this.FilesToUpload[i].percentage == 500 || Math.abs(parseInt(this.FilesToUpload[i].fileSize)) < 1024 * 1024 * 2) {
                this.nextBatchProcessNewFile(i + 1);
            }
            else {
                this.nextBatchProcess(i);
            }
        }
    }

    nextBatchProcess(i: any) {
        if (this.FilesToUpload[i].fileChunks?.length > 0 && this.FilesToUpload[i].percentage != 500 && this.FilesToUpload[i].percentage != 600) {
            var remainder = this.FilesToUpload[i].fileChunksLength % 1;
            var num = 1;
            if (this.FilesToUpload[i].fileChunks.length === remainder || this.FilesToUpload[i].fileChunks.length < 1) {
                num = this.FilesToUpload[i].fileChunks.length;
            }

            for (var countChunk = 0; countChunk < num; countChunk++) {
                if (this.FilesToUpload[i].fileChunks[countChunk] != null && this.FilesToUpload[i].attachmentKey != this.failedAttachmentKey) {
                    if (this.FilesToUpload[i].percentage == 100 || this.FilesToUpload[i].percentage == 600 || this.FilesToUpload[i].percentage == 500) {
                        this.nextBatchProcessNewFile(i + 1);
                    }
                    else {
                        this.upload(this.FilesToUpload[i].fileChunks[countChunk].targetFile,
                            this.FilesToUpload[i].fileChunks[countChunk].id,
                            null,
                            this.FilesToUpload[i].fileSize,
                            this.FilesToUpload[i].fileName,
                            this.FilesToUpload[i].fileChunksLength,
                            this.FilesToUpload[i].attachmentKey
                        );
                    }
                }
            }
        }
        else {
            this.nextBatchProcessNewFile(i + 1);
        }
    }

    upload(chunk: any, chunkorfileId: any, objXhr1: any, fileSize: any, fileName: any, totalChunks: any, attachmentKey: any) {
        try {
            this.showAttachmentLoader = true;
            if (!this.fullAttachmentKeyList.includes(attachmentKey)) {
                this.fullAttachmentKeyList.push(attachmentKey);
            }
            this.uploadChunks = 0;
            fileName = this.ReplaceCurlyQuotesInFileName(fileName);
            var logKey = this.activityType === "Lead" ? this.leadKey : this.caseKey;

            if (totalChunks == 0) {
                console.log("File: " + fileName + ". Uploading full file.");
            }
            else {
                console.log("File: " + fileName + ". Uploading chunk: " + (chunkorfileId + 1) + " of " + totalChunks);
            }
            var baseUrl = environment.baseUri;
            var url =
                baseUrl + 'FCReferral/UploadAttachment?attachmentKey='
                +
                attachmentKey;

            var objXhr: any;
            objXhr = new XMLHttpRequest();
            var data = new FormData();

            data.append('uploadedFile', chunk);
            objXhr.upload.fileId = chunkorfileId;
            objXhr.upload.fileName = fileName;
            objXhr.upload.attachmentKey = attachmentKey;

            objXhr.timeout = 3600000;
            objXhr.open('POST', url);
            objXhr.setRequestHeader("X-Content-Name", fileName);
            objXhr.setRequestHeader("Ocp-Apim-Subscription-Key", environment.subscriptionKey);

            //if its a small file no need for custom headers
            if (totalChunks !== 0) {
                objXhr.setRequestHeader("X-Chunk-Id", chunkorfileId);
                objXhr.setRequestHeader("X-Content-Length", fileSize);
                objXhr.setRequestHeader("X-Total-Chunks", totalChunks);

                if (chunkorfileId === totalChunks - 1) {
                    objXhr.setRequestHeader("X-Last-Chunk", "true");
                }
                else
                    objXhr.setRequestHeader("X-Last-Chunk", "false");
            }

            objXhr.onerror = () => {
                this.updateProgressForGeneralErrors(objXhr.upload.fileName);
            }

            objXhr.ontimeout = () => {
                this.updateProgressForGeneralErrors(objXhr.upload.fileName);
            };

            if (fileSize <= (1024 * 1024 * 2)) {
                this.FilesToUpload[chunkorfileId].xmlObj = objXhr;
                objXhr.upload.addEventListener('progress', (evt: ProgressEvent) => this.updateSmallFileProgress(evt), false);
                objXhr.onload = () => {
                    if (objXhr.status != 200) {
                        this.updateProgressForGeneralErrors(objXhr.upload.fileName);
                    } else if (objXhr.status == 200) {
                        this.updateProgressForSmallFiles(objXhr.upload.fileName);
                    }
                };
            }
            else {
                objXhr.upload.addEventListener('progress', (evt: ProgressEvent) => this.updateChunkProgress(evt), false);
                objXhr.onload = () => {
                    if (objXhr.status != 200) {
                        this.updateProgressForGeneralErrors(objXhr.upload.fileName);
                    } else if (objXhr.status == 200) {
                        this.updateProgress(objXhr.upload.fileId, objXhr.upload.fileName);
                    }
                };
            }

            objXhr.send(data);
        }
        catch (e) {
            this.showAttachmentLoader = false;
            var result = (e as Error).message as String;
            if (result.includes('String contains non ISO-8859-1 code point')) {
                this.updateProgressForErrorFiles(fileName);
            }
            else {

                this.updateProgressForGeneralErrors(fileName);
            }
        }
    };

    updateSmallFileProgress(e: any) {
        if (!e.lengthComputable) return;
        const fileName = e.currentTarget.fileName;
        const idx = this.FilesToUpload.findIndex((f: any) => f.fileName === fileName);
        if (idx === -1) return;
        const file = this.FilesToUpload[idx];
        if (file.percentage === 500 || file.percentage === 600 || file.failureToUpload) return;
        const percent = Math.min(Math.round((e.loaded / e.total) * 100), 100);
        if (percent > file.percentage) {
            file.percentage = percent;
            this.cdref.detectChanges();
        }
    }

    updateChunkProgress(e: any) {
        if (!e.lengthComputable) return;
        const fileName = e.currentTarget.fileName;
        const idx = this.FilesToUpload.findIndex((f: any) => f.fileName === fileName);
        if (idx === -1) return;
        const file = this.FilesToUpload[idx];
        if (file.percentage === 500 || file.percentage === 600 || file.failureToUpload) return;
        const confirmedBytes = Number(file.uploadedBytesConfirmed ?? 0);
        const rawPercent = ((confirmedBytes + e.loaded) / file.fileSize) * 100;
        const perc = Math.min(Math.floor(rawPercent), 99);
        if (perc > file.percentage) {
            file.percentage = perc;
            this.cdref.detectChanges();
        }
    }

    updateProgressForSmallFiles(fileName: any) {
        this.keyOfFilesmall = -1;
        this.FilesToUpload.forEach((value: any, key: any) => {
            if (value.fileName === fileName) {
                this.keyOfFilesmall = key;
            }
        });

        if (this.keyOfFilesmall === -1) {
            return;
        }

        const attachment = this.FilesToUpload[this.keyOfFilesmall];

        if (!attachment) {
            return;
        }

        if (attachment.percentage != 500 && attachment.percentage != 600 && attachment.failureToUpload == false) {
            attachment.percentage = 100;

            if (!this.fullAttachmentKeyList.includes(attachment.attachmentKey)) {
                this.fullAttachmentKeyList.push(attachment.attachmentKey);
            }
        }

        const allUploaded = this.FilesToUpload.every((file: any) => file.percentage === 100);
        if (allUploaded) {
            this.showAttachmentLoader = false;
            const newKeys = this.FilesToUpload
                .filter((f: any) => f.percentage === 100 && f.attachmentKey !== undefined)
                .map((f: any) => f.attachmentKey);

            newKeys.forEach((key: any) => {
                if (!this.alreadyUploadedFilesAttachmentKeys.includes(key)) {
                    this.alreadyUploadedFilesAttachmentKeys.push(key);
                }
            });
            this.fcservice.pollStatus(5000, this.alreadyUploadedFilesAttachmentKeys).subscribe(status => {
                if (status) {
                    console.log('Condition met, stopping polling.', status);
                    this.updateScanStatusPerFile(status);
                    let allClean = true;
                    if (Array.isArray(status)) {
                        status.forEach(item => {
                            if (item.VirusScanStatus !== 1 && item.fileName && this.FilesToUpload.some((f: any) => f.fileName === item.fileName)) {
                                allClean = false;
                            }
                        });
                    } else {
                        allClean = false;
                    }
                    if (allClean) {
                        this.vendorService.sendUploadEndData(true);
                    } else {

                    }
                }
                else {
                    console.log('Condition not met, polling continues.');
                }
            });
        }
        else {
            let allUploadCompleted = this.FilesToUpload.every((file: any) => (file.percentage === 100 || file.percentage === 500 || file.percentage === 600));
            let fileHasIssue = this.FilesToUpload.some((file: any) => file.percentage === 500 || file.percentage === 600);
            let anyFileUploadCompleted = this.FilesToUpload.some((file: any) => file.percentage === 100);
            if(allUploadCompleted && anyFileUploadCompleted) {
                const newKeys = this.FilesToUpload
                    .filter((f: any) => f.percentage === 100 && f.attachmentKey !== undefined)
                    .map((f: any) => f.attachmentKey);

                newKeys.forEach((key: any) => {
                    if (!this.alreadyUploadedFilesAttachmentKeys.includes(key)) {
                        this.alreadyUploadedFilesAttachmentKeys.push(key);
                    }
                });
                this.fcservice.pollStatus(5000, this.alreadyUploadedFilesAttachmentKeys).subscribe(status => {
                });
            }
            if(allUploadCompleted && fileHasIssue) {
                this.showAttachmentLoader = false;
            }
        }
    }

    updateProgress(chunkId: any, fileName: any): void {

        const fileIndex = this.FilesToUpload?.findIndex((file: any) => file.fileName === fileName);

        if (fileIndex === -1) return; // Exit if the file is not found

        const currentFile = this.FilesToUpload[fileIndex];

        if (currentFile.percentage != 500 && currentFile.percentage != 600 && currentFile.failureToUpload == false) {
            const completedChunk = currentFile.fileChunks.find((chunk: any) => chunk.id === chunkId);
            const completedChunkBytes = completedChunk?.targetFile?.size ?? 0;

            currentFile.noOfchunksSent++;
            currentFile.uploadedBytesConfirmed = Number(currentFile.uploadedBytesConfirmed ?? 0) + completedChunkBytes;

            const confirmedBytes = Number(currentFile.uploadedBytesConfirmed ?? 0);
            const perc = isNaN(confirmedBytes / currentFile.fileSize)
                ? 0
                : Math.min(Math.floor((confirmedBytes / currentFile.fileSize) * 100), 99);
            if (perc > currentFile.percentage) {
                currentFile.percentage = perc;
            }
            const remainder = currentFile.fileChunksLength % 1;
            const chunkIndex = currentFile.fileChunks.findIndex((chunk: any) => chunk.id === chunkId);

            if (chunkIndex > -1) {
                currentFile.fileChunks.splice(chunkIndex, 1);
            }

            const isEndOfBatch = Math.floor(currentFile.noOfchunksSent % 1) === 0;
            const isLastRemainder = currentFile.fileChunks.length === remainder && currentFile.fileChunks.length > 0;
            const isUploadComplete = currentFile.fileChunksLength === currentFile.noOfchunksSent;

            if (!isUploadComplete && (isEndOfBatch || isLastRemainder)) {
                this.nextBatchProcess(fileIndex);
            } else if (isUploadComplete) {
                currentFile.percentage = 100;
                this.vendorService.commitLargeFiles(currentFile.attachmentKey, currentFile.fileName, currentFile.fileChunksLength).subscribe(
                    (data: any) => {
                        if (!this.fullAttachmentKeyList.includes(currentFile.attachmentKey)) {
                            this.fullAttachmentKeyList.push(currentFile.attachmentKey);
                        }
                        const allUploaded = this.FilesToUpload.every((file: any) => file.percentage === 100);
                        if (allUploaded) {
                            this.showAttachmentLoader = false;
                            const newKeys = this.FilesToUpload
                                .filter((f: any) => f.percentage === 100 && f.attachmentKey !== undefined)
                                .map((f: any) => f.attachmentKey);

                            newKeys.forEach((key: any) => {
                                if (!this.alreadyUploadedFilesAttachmentKeys.includes(key)) {
                                    this.alreadyUploadedFilesAttachmentKeys.push(key);
                                }
                            });
                            this.fcservice.pollStatus(5000, this.alreadyUploadedFilesAttachmentKeys).subscribe(status => {
                                if (status) {
                                    console.log('Condition met, stopping polling.', status);
                                    this.updateScanStatusPerFile(status);
                                    let allClean = true;
                                    if (Array.isArray(status)) {
                                        status.forEach(item => {
                                            if (item.VirusScanStatus !== 1) {
                                                allClean = false;
                                            }
                                        });
                                    } else {
                                        allClean = false;
                                    }

                                    if (allClean) {
                                        this.vendorService.sendUploadEndData(true);
                                    } else {

                                    }
                                }
                                else {
                                    console.log('Condition not met, polling continues.');
                                }
                            });
                        }
                        else {
                            let allUploadCompleted = this.FilesToUpload.every((file: any) => (file.percentage === 100 || file.percentage === 500 || file.percentage === 600));
                            let fileHasIssue = this.FilesToUpload.some((file: any) => file.percentage === 500 || file.percentage === 600);
                            let anyFileUploadCompleted = this.FilesToUpload.some((file: any) => file.percentage === 100);
                            if(allUploadCompleted && anyFileUploadCompleted) {
                                const newKeys = this.FilesToUpload
                                    .filter((f: any) => f.percentage === 100 && f.attachmentKey !== undefined)
                                    .map((f: any) => f.attachmentKey);

                                newKeys.forEach((key: any) => {
                                    if (!this.alreadyUploadedFilesAttachmentKeys.includes(key)) {
                                        this.alreadyUploadedFilesAttachmentKeys.push(key);
                                    }
                                });
                                this.fcservice.pollStatus(5000, this.alreadyUploadedFilesAttachmentKeys).subscribe(status => {
                                });
                            }

                            if(allUploadCompleted && fileHasIssue) {
                                this.showAttachmentLoader = false;
                            }
                        }
                    });
                if (this.FilesToUpload[fileIndex + 1]) {
                    this.nextBatchProcessNewFile(fileIndex + 1);
                }
            }
        }
    }

    updateProgressForGeneralErrors(fileName: any) {
        this.FilesToUpload.forEach((value: any, key: any) => {
            if (value.fileName === fileName)
                this.keyOfFile = key;
        });
        if (this.FilesToUpload[this.keyOfFile].percentage != 600) {
            var percentage = 600;
            this.FilesToUpload[this.keyOfFile].percentage = percentage;
            this.FilesToUpload[this.keyOfFile].failureToUpload = true;
        }
        if (this.FilesToUpload[parseInt(this.keyOfFile) + 1]) {
            this.nextBatchProcessNewFile(parseInt(this.keyOfFile) + 1);
        }
    }

    updateProgressForErrorFiles(fileName: any) {
        this.FilesToUpload.forEach((value: any, key: any) => {
            if (value.fileName === fileName)
                this.keyOfFilesmall = key;
        });
        if (this.FilesToUpload[this.keyOfFilesmall].percentage != 500) {
            var percentage = 500;
            this.FilesToUpload[this.keyOfFilesmall].percentage = percentage;
            this.FilesToUpload[this.keyOfFilesmall].failureToUpload = true;
            // this.notificationService.add({
            //     type: 'info', title: this.notificationTranslate['File'], body: this.notificationTranslate['File '] + this.FilesToUpload[this.keyOfFilesmall].fileName + ' ' + this.notificationTranslate['upload has failed. Please rename the file completely and try again.']
            // });
        }
    }

    ReplaceCurlyQuotesInFileName(fileName: any) {
        if (fileName && (fileName.indexOf('\u2018') || fileName.indexOf('\u2019')))
            return fileName.replace(/[\u2018\u2019]/g, "'");
    }

    humanFileSize(bytes: any, si: any) {
        var thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }

    checkFileType(fileType: any) {
        switch (fileType.toLowerCase()) {
            case "doc":
                return true;
            case "docx":
                return true;
            case "pdf":
                return true;
            case "xls":
                return true;
            case "xlsx":
                return true;
            case "jpeg":
                return true;
            case "jpg":
                return true;
            case "bmp":
                return true;
            case "png":
                return true;
            case "tif":
                return true;
            case "tiff":
                return true;
            case "wav":
                return true;
            case "mp3":
                return true;
            case "zip":
                return true;
            case "txt":
                return true;
            case "text/plain":
                return true;
            case "htm":
                return true;
            case "html":
                return true;
            case "csv":
                return true;
            case "ppt":
                return true;
            case "pptx":
                return true;
            case "msg":
                return true;
            case "eml":
                return true;
            default:
                return false;
        }
    };

    getProgressValue(attachment: any): number {
        const percentage = Number(attachment?.percentage ?? 0);

        if(percentage === 100 && Number(attachment?.scanStatus) === 1) 
        {
            return 100;
        }

        if (percentage === 100 && Number(attachment?.scanStatus) !== 1) {
            return 99;
        }

        return Math.round(percentage);
    }

    private updateScanStatusPerFile(status: any): void {
        if (!Array.isArray(status)) {
            return;
        }

        status.forEach((item: any) => {
            const matchedFile = this.FilesToUpload.find((f: any) =>
                (item?.AttachmentKey !== undefined && f.attachmentKey === item.AttachmentKey) ||
                (item?.fileName !== undefined && f.fileName === item.fileName)
            );

            if (!matchedFile) {
                return;
            }

            matchedFile.scanStatus = item?.VirusScanStatus;
        });
    }
    //<END> CODE ADDED FOR NEW UPLOAD FUNCTIONALITY

    clearClass() {
        let fileLabel = document.getElementById('fileLabel');
        if (fileLabel) {
            fileLabel.style.backgroundColor = 'white';
        }
    }

    addClass() {
        let fileLabel = document.getElementById('fileLabel');
        if (fileLabel) {
            fileLabel.style.backgroundColor = 'white';
        }
    }

    ngOnDestroy() {
        if (this.uploadStartDataSub) {
            this.uploadStartDataSub.unsubscribe();
        }
        this.showAttachmentLoader = false;
    }
}
